import type { Moment } from 'moment';

export const displaySelectedWeek = (value: Moment) => {
  const startOfWeek = value.clone().startOf('week');
  const endOfWeek = value.clone().endOf('week');
  return `${startOfWeek.format('YYYY/MM/DD')} - ${endOfWeek.format(
    'YYYY/MM/DD'
  )}`;
};
